var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/common/authentication.service';
import { LoggerService } from 'src/app/services/common/logger.service';
import { MessageType, ToastService } from 'src/app/services/common/toast.service';
import { UserService } from 'src/app/services/data/user.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(fb, route, router, authService, userService, log, toastService) {
        this.fb = fb;
        this.route = route;
        this.router = router;
        this.authService = authService;
        this.userService = userService;
        this.log = log;
        this.toastService = toastService;
        this.isLogging = false;
        var params = this.route.snapshot.queryParamMap;
        this.returnUrl = params.get('returnUrl');
        // If there is a return URL and the user is already authenticated,
        // redirect to the return URL.
        if (this.returnUrl && this.userService.currentUser) {
            this.router.navigateByUrl(this.returnUrl);
        }
        this.form = this.fb.group({
            userName: ['', Validators.required],
            password: ['', Validators.required],
        });
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.focusOnLogin();
    };
    LoginComponent.prototype.focusOnLogin = function () {
        var _this = this;
        setTimeout(function () {
            _this.usernameElt.inputElement.nativeElement.focus();
            _this.usernameElt.inputElement.nativeElement.select();
        }, 300);
    };
    LoginComponent.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var val;
            var _this = this;
            return __generator(this, function (_a) {
                // Clear previous toasts.
                this.toastService.clearToasts();
                this.isLogging = true;
                val = this.form.value;
                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var err_1;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(val.userName && val.password)) return [3 /*break*/, 5];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, this.authService.login(val.userName, val.password)];
                            case 2:
                                _a.sent();
                                this.toastService.addToast('Authentification réussie', MessageType.SUCCESS, 2000);
                                this.log.debug('User is logged in');
                                this.isLogging = false;
                                setTimeout(function () {
                                    _this.router.navigateByUrl(_this.returnUrl || '');
                                }, 300);
                                return [3 /*break*/, 4];
                            case 3:
                                err_1 = _a.sent();
                                this.isLogging = false;
                                this.log.error(err_1);
                                this.toastService.showError(err_1);
                                this.focusOnLogin();
                                return [3 /*break*/, 4];
                            case 4: return [3 /*break*/, 6];
                            case 5:
                                this.isLogging = false;
                                this.toastService.addToast('Veuillez renseigner votre identifiant et votre mot de passe', MessageType.ERROR);
                                this.focusOnLogin();
                                _a.label = 6;
                            case 6: return [2 /*return*/];
                        }
                    });
                }); }, 400);
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.logout = function () {
        this.authService.logout();
    };
    return LoginComponent;
}());
export { LoginComponent };
